/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  // Le o preco exibido (com ou sem preco "de/por") e recalcula as 12x com o mesmo fator do Liquid (1.2211).
  var $lista = $('.product-form__info-item .price-list');
  var $preco = $lista.find('.price--highlight');
  if (!$preco.length) $preco = $lista.find('.price').not('.price--compare');
  var precoText = $preco.first().contents().filter(function () { return this.nodeType === 3; }).text();
  var preco = parseFloat(precoText.replace(/[^\d,]/g, '').replace(',', '.'));
  if (isNaN(preco)) return;
  var compare = parseFloat($lista.find('.price--compare').first().text().replace(/[^\d,]/g, '').replace(',', '.'));
  if (!isNaN(compare) && compare > preco) {
    $('.product-label.product-label--on-sale span').text('R$ ' + (compare - preco).toFixed(2).replace('.', ','));
    $('.price--highlight .product-label.product-label--on-sale').text('-' + Math.floor((compare - preco) * 100 / compare) + '%');
  }
  var calculo = 'R$ ' + (preco * 1.2211 / 12).toFixed(2).replace('.', ',');
  var $p = $lista.find('.parcelamento');
  if (!$p.length) { $p = $('<p class="parcelamento" style="font-size:16px"></p>'); $lista.append($p); }
  $p.html('em até 12x de <span style="font-size:20px; color: black;"><b>' + calculo + '</b></span>');
}


$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});